import { Script } from "gatsby"
import React, { useState } from "react"

const GraciasTracking = () => {
  const [loaded, setLoaded] = useState(false)
  return (
    <>
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=G-5TYM9DPM2K"
        onLoad={() => setLoaded(true)}
      />
      {loaded && (
        <>
          <Script
            id="second-id"
            dangerouslySetInnerHTML={{
              __html: `
              window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-5TYM9DPM2K');
              `,
            }}
            crossorigin="anonymous"
          />
        </>
      )}
    </>
  )
}

export default GraciasTracking
